import type { PressGridProps } from './interfaces';
import styles from './PressGrid.module.scss';
import Card from '../Card/Card';

const PressGrid = ({ items }: PressGridProps) => {
  const cardItems = items.map((article) => (
    <article key={article.headline}>
      <Card
        image={article.image}
        headline={article.headline}
        text={article.text}
        tag={article.tag}
        linkintern={article.linkintern}
        date={article.date}
      />
    </article>
  ));

  return <div className={styles.grid}>{cardItems}</div>;
};

export default PressGrid;
